// removed by extract-text-webpack-plugin
module.exports = {"image-frame":"Image__image-frame","imageFrame":"Image__image-frame","image-click":"Image__image-click","imageClick":"Image__image-click"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Image/Image.css
// module id = 1155
// module chunks = 8